import { memo } from 'react';
import { Typography, Rating as MuiRating } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { getShowById } from '@client/selectors/entities/shows';
import { useInstanceSelector } from '@client/hooks/redux.hooks';

const useStyles = makeStyles({ name: 'ShowTitle' })(() => ({
  root: {
    '& > span': {
      verticalAlign: 'middle',
    },
  },
  rating: {
    display: 'inline-flex',
  },
}));

interface ShowTitleProps {
  readonly score: number;
  readonly showId: string;
}

export const ShowTitle = memo<ShowTitleProps>(({ score, showId }) => {
  const { classes } = useStyles();
  const show = useInstanceSelector(getShowById, showId);

  return (
    <Typography
      variant="overline"
      color="textSecondary"
      className={classes.root}
      gutterBottom
    >
      {score > 0 && (
        <MuiRating
          className={classes.rating}
          size="small"
          value={score}
          readOnly
        />
      )}

      <span>{show.title}</span>
    </Typography>
  );
});
